'use client';

import { useEffect, useState } from 'react';

const STORAGE_KEY = 'f9_cookie_consent_v2';
const CONSENT_VERSION = '1.0';
type OptionalCategory = 'preferences' | 'analytics' | 'marketing';
type Choices = Record<OptionalCategory, boolean>;
const rejected: Choices = { preferences: false, analytics: false, marketing: false };

function saveConsent(choices: Choices) {
  const value = { version: CONSENT_VERSION, decidedAt: new Date().toISOString(), necessary: true, ...choices };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent('ferty9:cookie-consent', { detail: value }));
}

export function CookieNotice() {
  const [ready, setReady] = useState(false);
  const [open, setOpen] = useState(false);
  const [hasDecision, setHasDecision] = useState(false);
  const [manage, setManage] = useState(false);
  const [choices, setChoices] = useState<Choices>(rejected);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null') as (Choices & { version?: string }) | null;
      if (stored?.version === CONSENT_VERSION) {
        setChoices({ preferences: !!stored.preferences, analytics: !!stored.analytics, marketing: !!stored.marketing });
        setHasDecision(true);
      }
      else setOpen(true);
    } catch { setOpen(true); }
    setReady(true);
  }, []);

  const close = () => { setOpen(false); setManage(false); };
  const commit = (next: Choices) => { saveConsent(next); setChoices(next); setHasDecision(true); close(); };
  if (!ready) return null;

  return <>
    {open && <div className="cookie-consent-layer" role="presentation" onMouseDown={event => {
      if (event.target === event.currentTarget) close();
    }}>
      <section className="cookie-consent" role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title" aria-describedby="cookie-consent-description">
        <div className="cookie-consent-heading"><span aria-hidden="true">◉</span><div><p>PRIVACY CONTROLS</p><h2 id="cookie-consent-title">Your cookie choices</h2></div></div>
        <p id="cookie-consent-description">We use strictly necessary technologies to secure and operate Ferty9 services. Optional categories remain off unless you choose them.</p>
        {manage && <div className="cookie-categories">
          <label><span><strong>Strictly necessary</strong><small>Sign-in, security and core service operation.</small></span><input type="checkbox" checked disabled aria-label="Strictly necessary cookies always enabled" /></label>
          <label><span><strong>Preferences</strong><small>Remember interface choices where available.</small></span><input type="checkbox" checked={choices.preferences} onChange={e => setChoices(v => ({ ...v, preferences: e.target.checked }))} /></label>
          <label><span><strong>Analytics</strong><small>Optional service measurement. Off by default.</small></span><input type="checkbox" checked={choices.analytics} onChange={e => setChoices(v => ({ ...v, analytics: e.target.checked }))} /></label>
          <label><span><strong>Marketing</strong><small>Optional campaign measurement where enabled. Off by default.</small></span><input type="checkbox" checked={choices.marketing} onChange={e => setChoices(v => ({ ...v, marketing: e.target.checked }))} /></label>
        </div>}
        <a className="cookie-policy-link" href="/cookies">Read the Cookie Policy</a>
        <div className="cookie-consent-actions">
          <button type="button" className="cookie-secondary" onClick={() => commit(rejected)}>Reject non-essential</button>
          {manage ? <button type="button" className="cookie-primary" onClick={() => commit(choices)}>Save preferences</button> : <button type="button" className="cookie-secondary" onClick={() => setManage(true)}>Manage preferences</button>}
          <button type="button" className="cookie-primary" onClick={() => commit({ preferences: true, analytics: true, marketing: true })}>Accept all</button>
        </div>
      </section>
    </div>}
    {!hasDecision && !open && <button type="button" className="cookie-settings-trigger" onClick={() => { setManage(true); setOpen(true); }}>Cookie settings</button>}
  </>;
}
